// Mock data for Autodemolizioni Busisi S.R.L. landing page
// NOTE: All data below is mocked for the frontend-only teaser.

export const company = {
  name: "Autodemolizioni Busisi S.R.L.",
  shortName: "Busisi",
  logoInitials: "AB",
  logoSubtitle: "MOTORI & AUTORICAMBI",
  whatsapp: "3935234760",
  whatsappDisplay: "393 523 4760",
  whatsappLink: "https://wa.me/393935234760",
  phones: [
    { raw: "3508960820", display: "350 896 0820" },
    { raw: "3935234760", display: "393 523 4760" },
  ],
  email: "info.busisidem@gmail.com",
  address: "Via Scansanese 255 - 58100 Grosseto (Toscana)",
  piva: "00951000538",
  hours: "Lun-Ven 09:00-17:00 \u00b7 Sab 09:00-13:00",
  since: "Dal 2010",
  soldLabel: "1.000+ motori venduti",
};

export const heroBg =
  "https://images.unsplash.com/photo-1618312980096-873bd19759a0?crop=entropy&cs=srgb&fm=jpg&q=80&w=1920";

export const heroBadges = [
  { icon: "CheckCircle2", text: "Garanzia 12-24 mesi" },
  { icon: "Truck", text: "Spedizione gratuita Italia" },
  { icon: "Wrench", text: "Testati e revisionati" },
  { icon: "PhoneCall", text: "Risposta in 1 ora" },
];

export const trustBadges = [
  { icon: "ShieldCheck", title: "Garanzia 24 mesi", sub: "Polizza assicurativa" },
  { icon: "FileCheck2", title: "Verifica P5", sub: "Compatibilit\u00e0 certa" },
  { icon: "Truck", title: "Spedizione", sub: "Tutta Italia 3-7 giorni" },
  { icon: "Award", title: "Dal 2010", sub: "16 anni di esperienza" },
];

export const stats = [
  { icon: "ShoppingCart", value: "1000+", label: "Motori venduti" },
  { icon: "Users", value: "800+", label: "Clienti soddisfatti" },
  { icon: "Award", value: "16", label: "Anni di esperienza", sub: "dal 2010" },
  { icon: "SlidersHorizontal", value: "35+", label: "Marche trattate" },
  { icon: "ShieldCheck", value: "12-24", label: "Mesi garanzia" },
  { icon: "CheckCircle2", value: "100%", label: "Motori testati", sub: "prima della vendita" },
  { icon: "Truck", value: "GRATIS", label: "Spedizione", sub: "tutta Italia" },
  { icon: "Clock", value: "24-48h", label: "Tempi", sub: "di consegna" },
];

export const services = [
  {
    title: "Motori usati",
    desc: "Provenienti da veicoli accuratamente selezionati, testati a freddo e dotati di chilometraggio certificato. Garanzia 6-12 mesi.",
    img: "https://images.unsplash.com/photo-1777900201609-ad2f57813ab8?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
  },
  {
    title: "Motori rettificati",
    desc: "Smontaggio totale, rilavorazione di testata, monoblocco e albero motore, sostituzione componenti usurate. Garanzia 24 mesi.",
    img: "https://images.unsplash.com/photo-1527383418406-f85a3b146499?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
  },
  {
    title: "Motori revisionati e rigenerati",
    desc: "Pari al nuovo: tutte le parti soggette a usura sostituite, collaudo finale di tenuta e prestazioni. Garanzia 24 mesi.",
    img: "https://images.unsplash.com/photo-1552656967-7a0991a13906?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
  },
  {
    title: "Verifica codice P5",
    desc: "Identifichiamo il motore esatto del tuo veicolo tramite codice P5 della carta di circolazione: nessun errore di compatibilit\u00e0.",
    img: "https://images.pexels.com/photos/8052843/pexels-photo-8052843.jpeg?auto=compress&w=800",
  },
];

export const steps = [
  { n: "1", title: "Richiedi preventivo", desc: "Compila il form WhatsApp con marca, modello e codice motore P5. Risposta in giornata." },
  { n: "2", title: "Ricevi quotazione", desc: "Ti inviamo un preventivo dettagliato con prezzo, tempi di consegna e condizioni di garanzia." },
  { n: "3", title: "Conferma e paga", desc: "Bonifico, contanti o pagamento al ritiro. Fattura sempre inclusa, anche per le officine." },
  { n: "4", title: "Spedizione gratuita", desc: "Consegna in 24/48h con corriere espresso, tracking incluso. Garanzia attiva alla consegna." },
];

export const brands = [
  ["AB", "Abarth"], ["AR", "Alfa Romeo"], ["AU", "Audi"], ["BM", "BMW"], ["CI", "Citroen"],
  ["CU", "Cupra"], ["DS", "DS"], ["DA", "Dacia"], ["FI", "Fiat"], ["FD", "Ford"],
  ["HO", "Honda"], ["HY", "Hyundai"], ["JP", "Jeep"], ["KI", "Kia"], ["LA", "Lancia"],
  ["LR", "Land Rover"], ["LX", "Lexus"], ["MZ", "Mazda"], ["MB", "Mercedes-Benz"], ["MI", "Mini"],
  ["MT", "Mitsubishi"], ["NI", "Nissan"], ["OP", "Opel"], ["PE", "Peugeot"], ["PO", "Porsche"],
  ["RE", "Renault"], ["SE", "Seat"], ["SK", "Skoda"], ["SM", "Smart"], ["SY", "SsangYong"],
  ["SU", "Subaru"], ["SZ", "Suzuki"], ["TE", "Tesla"], ["TO", "Toyota"], ["VW", "Volkswagen"], ["VO", "Volvo"],
];

export const couriers = [
  { code: "BRT", label: "Corriere espresso" },
  { code: "GLS", label: "General Logistics" },
  { code: "SDA", label: "Express Courier" },
];

export const reasons = [
  { icon: "Award", title: "16 anni di esperienza", desc: "Dal 2010 nel settore. Conosciamo ogni motore, ogni marca, ogni problematica meccanica. La nostra esperienza \u00e8 il tuo vantaggio." },
  { icon: "Car", title: "35+ marche trattate", desc: "Auto, furgoni e veicoli commerciali di tutte le principali case europee e asiatiche. Se non trovi la tua marca, chiedicelo." },
  { icon: "ShieldCheck", title: "Garanzia 12-24 mesi", desc: "Polizza assicurativa primaria su tutti i motori rettificati e rigenerati. Sai esattamente cosa \u00e8 coperto e per quanto tempo." },
  { icon: "Truck", title: "Spedizione gratuita Italia", desc: "Consegna in 24/48h con corriere espresso, tracking incluso. Spediamo in tutta Italia, isole comprese, senza costi extra." },
  { icon: "Headphones", title: "Consulenza tecnica gratuita", desc: "Prima dell'acquisto i nostri tecnici ti aiutano a identificare il motore giusto per il tuo veicolo tramite il codice P5." },
  { icon: "Package", title: "Imballaggio rinforzato", desc: "Pallet di legno certificato, fissaggio meccanico con cinghie, protezione angolare e film estensibile. Il motore arriva intatto." },
];

export const testimonials = [
  { text: "Motore Fiat Ducato rettificato consegnato in 48h. Imballaggio impeccabile, garanzia scritta inclusa. Funziona perfettamente da 8 mesi. Riacquister\u00f2 sicuramente.", name: "Marco R.", role: "Titolare autofficina, Brescia" },
  { text: "Ho cercato a lungo un motore per la mia BMW 320d e qui l'ho trovato a un ottimo prezzo. Consulenza tecnica al telefono molto utile, mi hanno aiutato a verificare il codice P5.", name: "Giorgio P.", role: "Cliente privato, Roma" },
  { text: "Lavoriamo con Busisi da anni. Motori sempre testati, garanzia chiara, spedizione rapida. Perfetti per le nostre esigenze di carrozzeria.", name: "Luca M.", role: "Carrozzeria, Napoli" },
  { text: "Avevo bisogno di un motore Audi A4 con poco chilometraggio. Trovato disponibile, spedito gratuitamente in 3 giorni. Tutto come da accordi, motore funzionante senza problemi.", name: "Stefano D.", role: "Cliente privato, Bari" },
  { text: "Servizio professionale dall'inizio alla fine. Mi hanno spiegato la differenza tra motore usato e rettificato e ho potuto scegliere consapevolmente. Garanzia 24 mesi, sono tranquillo.", name: "Andrea F.", role: "Cliente privato, Torino" },
  { text: "Officina convenzionata. Prezzi competitivi e prodotti garantiti. La fattura \u00e8 sempre puntuale e il rapporto qualit\u00e0-prezzo \u00e8 eccellente. Consiglio.", name: "Roberto C.", role: "Officina meccanica, Palermo" },
];

export const navLinks = [
  { label: "Catalogo", href: "#catalogo" },
  { label: "Cosa offriamo", href: "#servizi" },
  { label: "Come acquistare", href: "#come-acquistare" },
  { label: "Marche", href: "#marche" },
  { label: "Recensioni", href: "#recensioni" },
];
